const SEPARATORS = /[\s-]/g;
const TEN_DIGITS = /^\d{10}$/;

const passesLuhn = (digits: string) => {
  const sum = digits
    .split('')
    .map((digit, index) => Number(digit) * (index % 2 === 0 ? 2 : 1))
    .reduce((total, product) => total + (product > 9 ? product - 9 : product), 0);
  return sum % 10 === 0;
};

// Mirrors toAccuratorOrgNumber in src/misc/orgNumber.js, the server's test for a Swedish number.
export const isSwedishOrgNumber = (orgNumber: string) => {
  const digits = orgNumber.replace(SEPARATORS, '');
  return TEN_DIGITS.test(digits) && passesLuhn(digits);
};
